import { ModalsKeys } from '../global';

const OPEN = 'OPEN';
const CLOSE = 'CLOSE';
const UPDATE = 'UPDATE';

type State = Partial<
  Record<
    ModalsKeys,
    {
      isOpen: boolean;
      data?: any;
    }
  >
>;

const initialState: State = {};

const modalsReducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case OPEN:
      return {
        ...state,
        [payload.modalKey]: { isOpen: true, data: payload?.data },
      };
    case CLOSE:
      return {
        ...state,
        [payload.modalKey]: { isOpen: false },
      };
    case UPDATE:
      return {
        ...state,
        [payload.modalKey]: {
          ...state[payload.modalKey as ModalsKeys],
          data: { ...state[payload.modalKey as ModalsKeys]?.data, ...payload.data },
        },
      };
    default:
      return state;
  }
};

// Actions

const onOpenModal = (modalKey: ModalsKeys, data: any = null) => ({
  type: OPEN,
  payload: { modalKey, data },
});

const onCloseModal = (modalKey: ModalsKeys) => ({
  type: CLOSE,
  payload: { modalKey },
});

const onUpdate = (modalKey: ModalsKeys, data: any = null) => ({
  type: UPDATE,
  payload: { modalKey, data },
});

// Selectors

const selectIsOpen = (state: any, modalKey: ModalsKeys) => state.modals?.[modalKey]?.isOpen;
const selectData = (state: any, modalKey: ModalsKeys) => state.modals?.[modalKey]?.data;
const openedModals = (state: any) =>
  Object.entries(state.modals)
    .filter(([key, modalState]) => !!(modalState as any)?.isOpen)
    .map(([key]) => key);

const actions = {
  onOpenModal,
  onCloseModal,
  onUpdate,
};

const modalsSelectors = {
  selectIsOpen,
  selectData,
  openedModals,
};

export { modalsReducer, modalsSelectors, actions };
